// Case workspace opens with several GETs at once. Two at a time keeps the API
// pool from stalling every one of them.
const MAX_IN_FLIGHT = 2;
let active = 0;
const queue = [];

function finish() {
  active -= 1;
  drain();
}

function drain() {
  while (active < MAX_IN_FLIGHT && queue.length) {
    const job = queue.shift();
    active += 1;
    Promise.resolve()
      .then(job.task)
      .then(job.resolve, job.reject)
      .finally(finish);
  }
}

export function runInLane(task) {
  return new Promise((resolve, reject) => {
    queue.push({ task, resolve, reject });
    drain();
  });
}
